import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { ErrorResponse } from 'react-router-dom';
import { ApiEndPoints } from '../authentication/api-path';
import { getAPIConfig } from '../authentication/services/get-api-config';
import { BuyNowPayload } from '../../../interfaces/modal/common';

export const buyNowCart = createAsyncThunk(
    'buyNowModal/buyNowCart',
    async (enrichedData: BuyNowPayload, thunkApi) => {
        try {
            const url = `${process.env.REACT_APP_API_URL}${ApiEndPoints.BuynowCart}`;
            const { data } = await axios.post(url, enrichedData, await getAPIConfig());

            if (data.status === 200) {
                return thunkApi.fulfillWithValue(data);
            } else {
                return thunkApi.rejectWithValue(data);
            }
        } catch (e) {
            const error = e as AxiosError<ErrorResponse>;
            if (error.response) {
                return thunkApi.rejectWithValue(error.response.data);
            } else {
                return thunkApi.rejectWithValue('Something went wrong while buying the product.');
            }
        }
    }
);
